import {
  trigger,
  transition,
  style,
  animate,
  query,
  group
} from '@angular/animations';

export const routeAnimation = trigger('routeAnimation', [
  transition('1 => 2', [ // Come over from left/right
    style({ height: '!', background: '!' }),
    query(':enter', style({ zIndex: 9999, transform: 'translateX(100%)' }), { optional: true }),
    query(':leave', style({ zIndex: 0, transform: 'translateX(0%)' }), { optional: true }),
    group([
      query(':enter', animate('300ms ease-in-out', style({ transform: 'translateX(0%)'})), { optional: true }),
      query(':leave', animate('300ms ease-in-out', style({ transform: 'translateX(-100%)'})), { optional: true }),
    ])
  ]),
  transition('2 => 1', [
    style({ height: '!', background: 'white' }),
    query(':enter', style({ zIndex: 0, transform: 'translateX(-100%)' }), { optional: true }),
    query(':leave', style({ zIndex: 9999, transform: 'translateX(0%)', background: 'white' }), { optional: true }),
    group([
      query(':leave', animate('300ms ease-in-out', style({ transform: 'translateX(100%)'})), { optional: true }),
      query(':enter', animate('300ms ease-in-out', style({ transform: 'translateX(0%)'})), { optional: true }),
    ])
  ]),
]);



// WEBPACK FOOTER //
// ./src/app/shared/animations/router.animations.ts